import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class LifestyleCards extends HTMLElement {
  constructor() {
    super();

    // bindings

    // privates
    this._node = this;
    this._swiper_el = this._node.querySelector(".swiper");
    this._pagination = this._node.querySelector(".pagination");

    // events
    this._swiper = new Swiper(this._swiper_el, {
      a11y: true,
      speed: 333,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      pagination: {
        el: this._pagination,
        clickable: true
      },
      keyboard: {
        enabled: false
      }
    });
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
  }
}
